// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"f973d428","179":"abf08781","438":"7237c2d4","447":"49dc06b5","514":"2019ca0e","600":"3d5ccc18"}[chunkId] + ".chunk.css";
};